import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useDataSave, {DataSaveType} from "../../core/services/query/hooks/useDataSave";
import Transfer from "../types/Transfer";

/**
 * Hook to POST a transfer to the API
 */
export default function useTransferPost(): DataSaveType<Transfer, Transfer> {
    const client = useAPIClient(undefined, false);
    client.onError(error => {
        throw error;
    });

    return useDataSave<Transfer, Transfer>(
        async (transferData: Transfer) => {
            return await client.post<Transfer>('transfers', transferData);
        }
    );
}
